const makeThemedClassReference = (themeRef, classRef) => `${classRef}${themeRef}`;

const resolveClassName = (themeRef, classRef) => classRef[0] === '$' ? makeThemedClassReference(themeRef, classRef.substring(1)) : classRef;

const cache = new Map();
const resolveStyles = (themeRef, styles) => {
  let themeCache = cache.get(themeRef);

  if (themeCache) {
    const cachedResolvedStyles = themeCache.get(styles);

    if (cachedResolvedStyles) {
      return cachedResolvedStyles;
    }
  } else {
    themeCache = new Map();
    cache.set(themeRef, themeCache);
  }

  const resolvedStyles = walkTreatModule(themeRef, styles);
  themeCache.set(styles, resolvedStyles);
  return resolvedStyles;
};

const walkTreatModule = (themeRef, styles) => {
  const clone = styles.constructor();

  for (let key in styles) {
    const value = styles[key];

    if (typeof value === 'string') {
      clone[key] = resolveClassName(themeRef, value);
    } else if (typeof value === 'object') {
      clone[key] = value ? walkTreatModule(themeRef, value) : value;
    } else {
      clone[key] = value;
    }
  }

  return clone;
};

const createTheme = null;
const style = null;
const styleMap = null;
const styleTree = null;
const globalStyle = null;

export { createTheme, globalStyle, resolveClassName, resolveStyles, style, styleMap, styleTree };
